// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__9Jf_X","label":"SetPasswdForm_label__2Yt79"};